import {getEnv} from './util.js';

const CONFIG = {
    DEV: {
        DOMAIN: 'http://localhost:3000/',
        API_BASE: 'http://localhost:33333/api/',
        WS_URL: 'ws://localhost:33333/',
        IMAGEKIT_ENDPOINT: 'https://ik.imagekit.io/nn3phmxu4z/',
    },
    STG: {
        DOMAIN: 'https://simona-cherry-stg-a8ac686837a6.herokuapp.com/',
        API_BASE: 'https://simona-cherry-stg-a8ac686837a6.herokuapp.com/api/',
        WS_URL: 'wss://simona-cherry-stg-a8ac686837a6.herokuapp.com/',
        IMAGEKIT_ENDPOINT: 'https://ik.imagekit.io/nn3phmxu4z/',
    },
    PRD: {
        DOMAIN: 'https://www.simonacherry.com/',
        API_BASE: 'https://www.simonacherry.com/api/',
        WS_URL: 'wss://www.simonacherry.com/',
        IMAGEKIT_ENDPOINT: 'https://ik.imagekit.io/nn3phmxu4z/',
    },
};

export default CONFIG[getEnv()];
